import { enumParser } from '#validation/common/parsers';
import { MemberType } from '../constants';
export const memberTypeParser = enumParser(MemberType);
